// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8d915f0c","312":"ae844b59"}[chunkId] + ".chunk.js";
};